import { makeAutoObservable, action } from 'mobx';

class GeneralSettingsStore {
  settings = {};

  constructor() {
    makeAutoObservable(this, {
      setSettings: action, // Marking setSettings as an action
    });
  }

  setSettings(newSettings) {
    this.settings = newSettings;
  }

  getSettings(id) {
    return this.settings[id] || '';
  }

  get siteTitle() {
    return this.getSettings('site_title');
  }

  get headerMenuItems() {
    return this.getSettings('header_menu_items');
  }

  get footerMenuItems() {
    return this.getSettings('footer_menu_items');
  }

  get copyrightText() {
    return this.getSettings('copyright');
  }

  get contactsAndSocial() {
    return this.getSettings('contacts_and_social');
  }

  get tagline() {
    return this.getSettings('tagline');
  }

  get logo() {
    return this.getSettings('logo');
  }

  get favicon() {
    return this.getSettings('favicon');
  }

  get shippingMethods() {
    return this.getSettings('shipping_methods');
  }

  get dateFormat() {
    return this.getSettings('date_format');
  }

  get timeFormat() {
    return this.getSettings('time_format');
  }

  get termsPage() {
    return this.getSettings('terms_page');
  }

  get minOrder() {
    return parseFloat(this.getSettings('min_order')) || 0;
  }
}

const generalSettingsStore = new GeneralSettingsStore();
export default generalSettingsStore;
